module.exports = __webpack_public_path__ + "img/email.6b8197fb.svg";